import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Utility } from 'src/app/core/common';
import { JobService } from 'src/app/services/job.service';
import { JobtitleService } from 'src/app/services/jobtitle.service';
import { LocationService } from 'src/app/services/location.service';
import { SharedService } from 'src/app/services/shared.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-job-browser',
  templateUrl: './job-browser.component.html',
  styleUrls: ['./job-browser.component.scss']
})
export class JobBrowserComponent implements OnInit {
  alphabets: string[];
  jobtitles: any[];
  locations: any[];
  Utility = Utility;
  params: any;
  current: any;
  jobSearch: any;
  location: any = {};

  constructor(private jobtitleService: JobtitleService, private route: ActivatedRoute,
    private sharedService: SharedService,
    private jobService: JobService,
    private locationService: LocationService) { }

  async ngOnInit() {
    this.route.params.subscribe(async params => await this.load(params));
  }

  async load(params: any) {
    this.params = params;
    this.alphabets = await this.jobtitleService.browseAlphabets();
    this.jobtitles = await this.jobtitleService.search({
      Keyword: params['a'] ? `${params['a']}.*` : undefined,
    });
    this.locations = (await this.locationService.getCities())
      .filter(_ => !params['l'] ? _.Importance == 2 : _.State == params['l']);

    const q = params['q'];//?.replace('+', ' ');
    this.current = this.jobtitles.find(_ => _.Title == q);
    if (this.current) {
      this.jobSearch = await this.jobService.search({
        Keyword: this.current?.Title,
        IsRemote: true
      }, 0, 5);
    }

    this.setSeo();

  }

  private setSeo() {
    this.sharedService.setTitle(this.current
      ? 'آگهی استخدام ' + this.current.Title
      : 'مشاغل کار در منزل و دورکاری'
    );
    this.sharedService.setKeywordsMeta(...(
      this.current
        ? [this.current.Title, this.current.DisplayTitle, this.current.AlternateDisplayTitle]
        : this.jobtitles.map(_ => _.DisplayTitle)
    ));
    this.sharedService.setDescriptionMeta(
      this.current?.Brief ||
      'تمام آگهی‌های استخدام ' + this.jobtitles.map(_ => _.Title).join('، ')
    );
    this.sharedService.resetNoIndex();
  }


}
